import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "ACC Pembatalan Paket", -1)
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "font-bold font-semibold text-base mb-3" }, "Biaya Tambahan", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "additional-fee rounded-lg px-2 py-1 mb-3" }
const _hoisted_7 = { class: "font-semibold text-sm color-blue-grey" }
const _hoisted_8 = { class: "font-semibold text-sm color-blue-grey" }
const _hoisted_9 = {
  key: 1,
  class: "text-xs color-blue-grey"
}
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "text-sm font-semibold" }, "Deskripsi", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-sm font-semibold"
}
const _hoisted_13 = {
  key: 1,
  class: "text-xs color-blue-grey"
}
const _hoisted_14 = {
  key: 0,
  class: ""
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "text-xs color-blue-grey" }, "- Tidak ada -", -1)
const _hoisted_17 = { class: "pt-5" }
const _hoisted_18 = { class: "flex gap-4 justify-start" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Konfirmasi")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowModal,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModal = $event)),
    dismissableMask: true,
    modal: true,
    style: {width: '50vw'},
    onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideDialog())),
    class: "dialog-confirm cancel-package-dialog"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_Button, {
            class: "btn-red font-semibold px-10 text-white",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black font-semibold px-10 py-1",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("section", null, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.dataSource?.TransPengirimanHdBiayaTambahans)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource?.TransPengirimanHdBiayaTambahans, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item.Id
                  }, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("p", _hoisted_7, _toDisplayString(item.MsBiayaTambahanNama), 1),
                      _createVNode("p", _hoisted_8, _toDisplayString(`Rp. ${new Number(item.Nominal).toLocaleString('id-ID')}`), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("p", _hoisted_9, "- Tidak ada -"))
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          (_ctx.dataSource?.Deskripsi)
            ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.dataSource?.Deskripsi), 1))
            : (_openBlock(), _createBlock("p", _hoisted_13, "- Tidak ada -"))
        ]),
        (_ctx.dataSource?.Filename)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("img", {
                src: `${_ctx.API_BASE}${_ctx.dataSource?.Filename}`,
                class: " object-cover h-18"
              }, null, 8, ["src"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_15, [
              _hoisted_16
            ]))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}